// loading.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private requestCount = 0;
  loading$ = new BehaviorSubject<boolean>(false);

  show() {
    console.log('test')
    this.requestCount++;
    this.loading$.next(true);
  }

  hide() {
    this.requestCount--;
    if (this.requestCount <= 0) {
      this.requestCount = 0;
      this.loading$.next(false);
    }
  }
}